<template>
	<fieldset class="_form-checkbox-field" :name="'privacy-check'" :error="displayErrors && !valid">
		<label class="relative">
			<input v-model="checked" class="hide-input" type="checkbox" @change="onInput" />
			<div class="tick relative" />
			<div class="-p-small no-select">
				<p>
					By submitting, you agree to our
					<nuxt-link to="https://burocratik.com/privacy-policy" target="_blank"
						>Privacy Policy</nuxt-link
					>.
				</p>
			</div>
		</label>
	</fieldset>
</template>

<script>
export default {
	inject: ['$form'],
	props: {
		displayErrors: { type: Boolean, default: false },
	},
	data() {
		return {
			value: undefined,
			valid: false,

			checked: false,
		}
	},

	mounted() {
		this.$nextTick(() => {
			this.valid = this.checked

			this.$form?.pushPrivacy('privacy-check', {
				value: this.checked,
				valid: this.checked,
			})
		})
	},
	methods: {
		onInput() {
			this.valid = this.checked

			this.$form?.setField('privacy-check', {
				value: this.checked,
				valid: this.checked,
			})
		},
	},
}
</script>

<style lang="scss">
._form-checkbox-field {
	--form-error-red: #dc3429;
	--color: #{$black};

	&[error='true'] {
		--color: var(--form-error-red);
	}

	&[data-hidden='true'] {
		opacity: 0;
		pointer-events: none;
	}

	position: relative;
	color: var(--color);

	@include min-width($xs) {
		._form-field-layout .g-col:last-child {
			padding-top: 0;
		}
	}

	label {
		position: relative;
		display: flex;
		align-items: center;
		gap: rs(12, 10);
		padding: rs(15, 10) 0;

		cursor: pointer;

		input.hide-input {
			position: absolute;
			width: 1px;
			height: 1px;
			margin: 0;
			opacity: 0;
			pointer-events: none;
			appearance: none;
			-webkit-appearance: none;
		}

		@include max-width($sm) {
			align-items: flex-start;
		}

		.tick {
			position: relative;
			flex: 0 0 auto;
			margin-top: 2px;

			width: rs(12, 12);
			height: rs(12, 12);

			border: 1px solid var(--color);
			border-radius: 100%;
			overflow: hidden;

			&:after {
				content: '';
				position: absolute;
				inset: 0;

				border-radius: inherit;
				background-color: var(--color);

				transform: scale(0);
				transition: transform 0.4s ease('m3.emphasized', 'accelerate');
				will-change: transform;
			}
		}

		@include hover {
			.tick:after {
				transform: scale(0.33);
				transition-timing-function: ease('m3.emphasized', 'decelerate');
			}
		}

		input[type='checkbox']:checked + .tick:after {
			transform: scale(1);
			transition-timing-function: ease('m3.emphasized', 'decelerate');
		}

		input[type='checkbox']:focus-visible + .tick {
			box-shadow: 0 0 0 3px rgba($black, 0.3);
		}
	}

	a {
		text-decoration: underline;
		text-decoration-thickness: 1px;
		text-underline-offset: 2px;
	}
}
</style>
